import * as qfIcon from '@qfei-design/icons-vue';
export default function qfeiIconImport(app) {
  Object.entries(qfIcon).forEach(([name, component]) => {
    app.component(name, component);
  });
}
